type Props = {
    tab: "direct" | "courses"
}

export const ChatsInfoPanel = ({tab}: Props) => {
    return (
        <div
            className="
                bg-white
                border
                rounded-2xl
                p-6
                sticky top-6
            "
        >
            {tab === "direct" ? <DirectInfo/> : <CoursesInfo/>}
        </div>
    )
}

const DirectInfo = () => (
    <div className="space-y-4">
        <div className="text-lg font-semibold">
            💬 Direct messages
        </div>

        <p className="text-sm text-gray-500">
            Personal conversations with students and mentors.
        </p>

        <ul className="text-sm text-gray-600 space-y-2">
            <li>• Ask questions</li>
            <li>• Give feedback</li>
            <li>• Discuss progress</li>
        </ul>

        <div className="
            mt-4
            p-4
            rounded-xl
            bg-emerald-50
            text-sm
            text-emerald-700
        ">
            Select a chat to start messaging
        </div>
    </div>
)


const CoursesInfo = () => (
    <div className="space-y-4">
        <div className="text-lg font-semibold">
            📚 Course chats
        </div>

        <p className="text-sm text-gray-500">
            Each course has its own discussion space.
        </p>

        <ul className="text-sm text-gray-600 space-y-2">
            <li>• Group discussions</li>
            <li>• Announcements</li>
            <li>• Student questions</li>
        </ul>

        <div className="
            mt-4
            p-4
            rounded-xl
            bg-gray-50
            text-sm
            text-gray-600
        ">
            Choose a course to view its chats
        </div>
    </div>
)

